import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';

import { FaqItemComponent } from './faq-item/faq-item.component';
import { HeaderAppearanceEvents } from '@unicup-ticketing/core';
import { Dispatcher } from '@ngrx/signals/events';

@Component({
  selector: 'ticketing-faq',
  imports: [FaqItemComponent],
  templateUrl: './faq.component.html',
  styleUrl: './faq.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FaqComponent implements OnInit {
  private readonly dispatcher = inject(Dispatcher);

  ngOnInit(): void {
    this.dispatcher.dispatch(HeaderAppearanceEvents.requestUnhero());
  }
}
